/* (ignored) */


/*****************
 ** WEBPACK FOOTER
 ** ./file (ignored)
 ** module id = 13
 ** module chunks = 0
 **/